import axios from 'axios';
import { getApiUrl, getApiKey } from './api';
import { CREDIT_PACKAGES as PACKAGES } from '../config/stripe-config';

// Esporta i pacchetti di crediti dal file di configurazione
export const CREDIT_PACKAGES = PACKAGES;

// Crea una sessione di checkout per il pagamento Stripe
export const createCheckoutSession = async (planId) => {
  try {
    const API_URL = getApiUrl();
    const API_KEY = getApiKey();
    
    const response = await axios.post(
      `${API_URL}/create-checkout-session`,
      { plan_id: planId },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'X-API-KEY': API_KEY
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

// Verifica una sessione di checkout
export const verifyCheckoutSession = async (sessionId) => {
  try {
    const API_URL = getApiUrl();
    const API_KEY = getApiKey();
    
    const response = await axios.get(
      `${API_URL}/verify-checkout-session/${sessionId}`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'X-API-KEY': API_KEY
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error verifying checkout session:', error);
    throw error;
  }
};

// Funzione wrapper per acquistare crediti
export const purchaseCredits = async (userId, planId) => {
  try {
    console.log(`Purchasing credits for user ${userId}, plan ${planId}`);
    const session = await createCheckoutSession(planId);
    // Reindirizza l'utente alla pagina di checkout di Stripe
    window.location.href = session.url;
    return session;
  } catch (error) {
    console.error('Error purchasing credits:', error);
    throw error;
  }
};

// Nuove funzioni per la configurazione manuale di Stripe

/**
 * Imposta manualmente la chiave segreta di Stripe
 * 
 * @param {string} secretKey - La chiave segreta di Stripe
 * @param {string} adminKey - La chiave di amministrazione
 * @returns {Promise<Object>} - La risposta dal server
 */
export const setStripeSecretKey = async (secretKey, adminKey = 'instarizz_admin_secret') => {
  try {
    const API_URL = getApiUrl();
    
    const response = await axios.post(
      `${API_URL}/api/admin/set-stripe-key`,
      { 
        secret_key: secretKey,
        admin_key: adminKey
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error setting Stripe secret key:', error);
    throw error;
  }
};

/**
 * Ottiene la configurazione attuale di Stripe
 * 
 * @returns {Promise<Object>} - La configurazione attuale di Stripe
 */
export const getStripeConfig = async () => {
  try {
    const API_URL = getApiUrl();
    
    const response = await axios.get(
      `${API_URL}/api/admin/get-stripe-config`,
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error getting Stripe configuration:', error);
    throw error;
  }
}; 